export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/viral_videos.b58d82e.svg";